export default {
      id: "google-usage",
      viewBox: "0 0 18 18",
      url: __webpack_public_path__ + "img/icons.b3fb107f.svg#google",
      toString: function () {
        return this.url;
      }
    }